export const tableHead = [
  {
    prop: 'to_clients.review_used.name',
    label: '校区名称',
    minWidth: '100px',
  },
  {
    prop: 'to_clients.school_code',
    label: '校区代码',
    minWidth: '100px',
  }, {
    prop: 'to_clients.review_used.user_mobile',
    label: '校长手机号',
    minWidth: '130px',
  },
  {
    prop: 'packet.name',
    label: '课程名称',
    minWidth: '100px',
  },
  {
    prop: 'packet.code',
    label: '课程编码',
    width: '120px',
  },
  {
    label: '授权形式',
    formatter: (row) => {
      const type = {
        1: '按账号',
        2: '按次数',
      };
      return type[row.auth_type];
    },
  },
  {
    prop: 'used_number',
    label: '上课次数',
  },
  {
    prop: 'auth_number',
    label: '授权次数',
  },
];
export const tableHead2 = [
  {
    prop: 'created_at',
    width: '100px',
    label: '授权时间',
  },
  {
    prop: 'cancel_auth_time',
    width: '100px',
    label: '取消时间',
  },
  {
    prop: 'created_users.name',
    label: '操作人名称',
    minWidth: '100px',
  },
  {
    prop: 'created_users.mobile',
    label: '操作人账号',
    minWidth: '130px',
  },
  {
    prop: 'from_clients.review_used.name',
    label: '操作校区',
    minWidth: '120px',
  },
];

export const formData = [
  {
    typeName: 'daterange',
    startPlaceholder: '授权时间(起)',
    endPlaceholder: '授权时间(尾)',
  },
  {
    typeName: 'input',
    placeholder: '请输入课程名称',
    model: 'like[packet_name]',
  },
  {
    typeName: 'select1',
    placeholder: '授权形式',
    model: 'equal[auth_type]',
    options: [
      {
        value: 1,
        label: '按账号',
      },
      {
        value: 2,
        label: '按次数',
      },
    ],
  },
  {
    typeName: 'select1',
    placeholder: '授权状态',
    model: 'equal[auth_status]',
    options: [
      {
        value: 0,
        label: '未授权',
      },
      {
        value: 1,
        label: '已授权',
      },
      {
        value: 2,
        label: '取消授权',
      },
    ],
  },
  // {
  //   typeName: 'inputSelectSearch',
  //   model: 'like[school_name]',
  //   options: [
  //     {
  //       value: 'like[school_name]',
  //       label: '校区名称',
  //     },
  //     {
  //       value: 'like[school_code]',
  //       label: '校区编码',
  //     },
  //     {
  //       value: 'like[master_mobile]',
  //       label: '校长手机',
  //     },
  //     {
  //       value: 'like[operate_user_name]',
  //       label: '操作人员',
  //     },
  //     {
  //       value: 'like[operate_school_name]',
  //       label: '操作校区',
  //     }],
  // },
];



// WEBPACK FOOTER //
// ./src/views/CourseStatistics/AuthorityStatistics/fields.js